// @flow

import { API_ENDPOINT } from 'shared/config';

export const fetchSageCompany = (
  code: string,
  redirectUri: string
): Promise<any> =>
  fetch(`${API_ENDPOINT}/sage/business_data`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      redirect_uri: redirectUri,
      code
    })
  })
    .then((response) => response.json())
    .then((json) => json);
export default fetchSageCompany;
